import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';

import {getContactOrgId} from './constants';

export const activateNiud = createAsyncThunk('BusinessActivateNiudSlice/activateNiud', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const contactOrgId = getContactOrgId(thunkAPI.getState().portalsBlock) || data.contactOrgId;
    const result = await ProviderManager.getProviderData('activateNiud', [
      data.idNumberType,
      data.idNumber,
      data.hostNumber,
      data.niudNumber,
      contactOrgId,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {serverError: true};
  }
});

const initialState = {
  formErrors: {},
  apiError: null,
  apiErrorMessage: null,
  apiSuccessMessage: null,
  isCompleted: false,
  referenceId: null,
  expectedPortTime: null,
};

const BusinessActivateNiudSlice = createSlice({
  name: 'BusinessActivateNiudSlice',
  initialState,
  reducers: {
    setFormErrors: (state, action) => {
      state.formErrors = action.payload;
    },
    clearApiError: (state) => {
      state.apiError = null;
      state.apiErrorMessage = null;
      state.apiSuccessMessage = null;
    },
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(activateNiud.fulfilled, (state, action) => {
      if (action.payload?.serverError) {
        state.apiError = 'GeneralError';
        state.apiErrorMessage = null;
        state.apiSuccessMessage = null;
        state.isCompleted = false;
        return;
      }

      if (action.payload?.isValid) {
        state.apiError = null;
        state.apiErrorMessage = null;
        state.apiSuccessMessage = action.payload?.successMessage || null;
        state.isCompleted = true;
        state.referenceId = action.payload.referenceId;
        state.expectedPortTime = action.payload.expectedPortTime;
      } else {
        state.apiError = action.payload?.errorCode || 'GeneralError';
        state.apiErrorMessage = action.payload?.errorMessage || null;
        state.apiSuccessMessage = null;
        state.isCompleted = false;
        state.expectedPortTime = null;
      }
    });
  },
});

export const {setFormErrors, clearApiError, resetState} = BusinessActivateNiudSlice.actions;
export default BusinessActivateNiudSlice.reducer;
